import { createAction } from 'redux-starter-kit';
import { message } from 'antd';
import { get, post, asViaUrl } from '../../../../utility/via-fetch';
import { requestStart, requestSucceded, requestFailed } from '../../../domain/requests/RequestActions';
import { putLegalDocuments, putLegalDocument, deleteLegalDocument } from '../../../domain/legalDocuments/legalDocumentActions';
import routeLocations from '../../../../utility/route-locations';

/**
 * An action that signifies a request to load some basic application config data
 */
export const loadLegalDocuments = createAction('LOAD_LEGAL_DOCUMENTS');

/**
 * A action that retrieves all legal document versions from the server
 */
export function requestLegalDocuments() {
  return async (dispatch) => {
    const requestId = dispatch(requestStart(loadLegalDocuments.toString()));
    dispatch(loadLegalDocuments(requestId));
    try {
      const legalDocuments = await get('/api/legal-documents', undefined, { });
      dispatch(putLegalDocuments(legalDocuments));
      dispatch(requestSucceded(requestId));
    } catch (error) {
      dispatch(requestFailed(requestId)); // We failed.
    }
  };
}

/**
 * An action that signifies a request to update some basic application config data
 * Bynx admin user ONLY.
 */
export const saveLegalDocument = createAction('SAVE_LEGAL_DOCUMENT');

/**
 * A action that saves a future version of a legal document to the database
 * @param {object} legalDocument object contiang the new content, the documentType and the effectiveDate.
 * @param {history} history The react router history object. If present this will push the user back to the main documents table.
 * @param {intl} intl required for the success message.
 */
export function requestSaveLegalDocument(legalDocument, history, intl) {
  return async (dispatch) => {
    const requestId = dispatch(requestStart(saveLegalDocument.toString()));
    dispatch(saveLegalDocument(requestId));
    try {
      const versionNumber = await post('/api/legal-documents', undefined, legalDocument);
      dispatch(putLegalDocument({
        ...legalDocument,
        versionNumber: versionNumber.value,
      }));
      message.success(intl.formatMessage({ id: 'itemUpdated' }, { item: intl.formatMessage({ id: `login.link.${legalDocument.documentType}` }) }));
      dispatch(requestSucceded(requestId));
      if (history) history.push(routeLocations.admin_legal_documents);
    } catch (error) {
      dispatch(requestFailed(requestId)); // We failed.
    }
  };
}


/**
 * A action that saves a future version of a legal document to the database and opens a preview in a new tab.
 * @param {object} legalDocument object contiang the new content, the documentType and the effectiveDate.
 */
export function requestSaveAndPreviewLegalDocument(legalDocument, intl) {
  return async (dispatch) => {
    const requestId = dispatch(requestStart(saveLegalDocument.toString()));
    dispatch(saveLegalDocument(requestId));
    try {
      const versionNumber = await post('/api/legal-documents', undefined, legalDocument);
      dispatch(putLegalDocument({
        ...legalDocument,
        versionNumber: versionNumber.value,
      }));
      dispatch(requestSucceded(requestId));
      message.success(intl.formatMessage({ id: 'itemUpdated' }, { item: intl.formatMessage({ id: `login.link.${legalDocument.documentType}` }) }));
      const win = window.open(asViaUrl(`${routeLocations.legal}/${legalDocument.documentType}/${versionNumber.value}`), '_blank');
      win.focus();
    } catch (error) {
      dispatch(requestFailed(requestId)); // We failed.
    }
  };
}

/**
 * A action that saves a future version of a legal document to the database and opens a preview in a new tab.
 * @param {object} documentType The documentType to remve the edit version of
 */
export function requestDeleteEditVersionDocument(documentType, history) {
  return async (dispatch) => {
    const requestId = dispatch(requestStart(saveLegalDocument.toString()));
    dispatch(saveLegalDocument(requestId));
    try {
      const versionNumber = await post(`/api/legal-documents/${documentType}/abandon`, undefined, {});
      history.push(routeLocations.admin_legal_documents);
      dispatch(deleteLegalDocument({ documentType, versionNumber: versionNumber.value }));
      dispatch(requestSucceded(requestId));
    } catch (error) {
      dispatch(requestFailed(requestId)); // We failed.
    }
  };
}
